//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

export enum FACEBOOK_INSTAGRAM_SETTINGS_ACTIONS {
  START_OAUTH = 'FACEBOOK_INSTAGRAM_SETTINGS.START_OAUTH',

  REQUEST_FACEBOOK_USER_TOKEN = 'FACEBOOK_INSTAGRAM_SETTINGS.REQUEST_FACEBOOK_USER_TOKEN',
  RECEIVE_FACEBOOK_USER_TOKEN_SUCCEEDED = 'FACEBOOK_INSTAGRAM_SETTINGS.RECEIVE_FACEBOOK_USER_TOKEN_SUCCEEDED',
  RECEIVE_FACEBOOK_USER_TOKEN_FAILED = 'FACEBOOK_INSTAGRAM_SETTINGS.RECEIVE_FACEBOOK_USER_TOKEN_FAILED',

  REQUEST_CONNECTED_IG_ACCOUNT = 'FACEBOOK_INSTAGRAM_SETTINGS.REQUEST_CONNECTED_IG_ACCOUNT',
  RECEIVE_CONNECTED_IG_ACCOUNT_SUCCEEDED = 'FACEBOOK_INSTAGRAM_SETTINGS.RECEIVE_CONNECTED_IG_ACCOUNT_SUCCEEDED',
  RECEIVE_CONNECTED_IG_ACCOUNT_FAILED = 'FACEBOOK_INSTAGRAM_SETTINGS.RECEIVE_CONNECTED_IG_ACCOUNT_FAILED',

  REQUEST_CONNECTED_IG_ACCOUNT_MULTIHANDLE = 'FACEBOOK_INSTAGRAM_SETTINGS.REQUEST_CONNECTED_IG_ACCOUNT_MULTIHANDLE',
  RECEIVE_CONNECTED_IG_ACCOUNT_SUCCEEDED_MULTIHANDLE = 'FACEBOOK_INSTAGRAM_SETTINGS.RECEIVE_CONNECTED_IG_ACCOUNT_SUCCEEDED_MULTIHANDLE',
  RECEIVE_CONNECTED_IG_ACCOUNT_FAILED_MULTIHANDLE = 'FACEBOOK_INSTAGRAM_SETTINGS.RECEIVE_CONNECTED_IG_ACCOUNT_FAILED_MULTIHANDLE',

  REQUEST_CONNECTED_FB_PAGE = 'FACEBOOK_INSTAGRAM_SETTINGS.REQUEST_CONNECTED_FB_PAGE',
  RECEIVE_CONNECTED_FB_PAGE_SUCCEEDED = 'FACEBOOK_INSTAGRAM_SETTINGS.RECEIVE_CONNECTED_FB_PAGE_SUCCEEDED',
  RECEIVE_CONNECTED_FB_PAGE_FAILED = 'FACEBOOK_INSTAGRAM_SETTINGS.RECEIVE_CONNECTED_FB_PAGE_FAILED',

  REQUEST_DEAUTH_FB = 'FACEBOOK_INSTAGRAM_SETTINGS.REQUEST_DEAUTH_FB',
  RECEIVE_DEAUTH_FB_SUCCEEDED = 'FACEBOOK_INSTAGRAM_SETTINGS.RECEIVE_DEAUTH_FB_SUCCEEDED',
  RECEIVE_DEAUTH_FB_FAILED = 'FACEBOOK_INSTAGRAM_SETTINGS.RECEIVE_DEAUTH_FB_FAILED',
}

export const CONFIGURE_ACCOUNTS_HELP_LINK =
  'https://support.bazaarvoice.com/s/article/Configuring-your-Facebook-and-Instagram-Account';

export const FB_REVENUE_ATTRIBUTION_HELP_LINK =
  'https://support.bazaarvoice.com/s/article/Facebook-Revenue-Attribution';
